module.exports = __webpack_public_path__ + "img/m-data.1b2e344e.png";